import { Box, Flex } from '@chakra-ui/react';
import { Stars02 } from '@kula-ai/icons-core';
import { matchBand } from '../../../helpers';

interface MatchPillProps {
  /** 0–100. */
  pct: number;
  /** Text shown in the pill. Defaults to `${pct}%`. */
  label?: string;
  /** Leading AI sparkle — on for candidate cards, off in table cells. */
  sparkle?: boolean;
}

// Relevance pill; colour follows the score band.
export const MatchPill = ({ pct, label, sparkle = false }: MatchPillProps) => {
  const band = matchBand(pct);
  return (
    <Flex
      align="center"
      gap="4px"
      flexShrink={0}
      display="inline-flex"
      px="8px"
      py="2px"
      borderRadius="full"
      bg={band.light}
      color={band.dark}
      fontSize="12px"
      fontWeight="600"
      maxW="100%"
      overflow="hidden"
      whiteSpace="nowrap"
      textOverflow="ellipsis"
    >
      {sparkle && (
        // Stars02 is a line glyph; fill the paths so the sparkle reads solid.
        <Box as="span" display="inline-flex" lineHeight="0">
          <Stars02 size={12} className="[&_path]:fill-current" />
        </Box>
      )}
      {label ?? `${pct}%`}
    </Flex>
  );
};
